import { gql } from '@apollo/client';

export const achievementFragment = gql`
    fragment AchievementFields on Achievement {
        id
        name
        description
        achievedOn
        levelAchievedOn
        rarity
        icon
        iconImageUrl
        iconImageUrlNotAchieved
        achievementLevels {
            name
            description
            target
            iconImageUrl
            iconImageColor
        }
        iconImageColor
        questIds
        achievementConditions {
            questIds
            target
            value
            metricType
        }
        categoryId
        templateId
    }
`;
